// import axios from "axios";
// import { useEffect, useState } from "react";
// import { Col, Row, Spinner } from "react-bootstrap";
// import { SubmitHandler, useForm } from "react-hook-form";
// import { IoMdArrowBack } from "react-icons/io";
// import { Link, useLocation, useNavigate } from "react-router-dom";
// import AuthScreenLayout from "../../../components/authScreenLayout/AuthScreenLayout";
// import TextInfo from "../../../components/textInfo/TextInfo";
// import TextInput, { EInputMode } from "../../../components/textInput/TextInput";
// import Title from "../../../components/title/Title";
// import {
//   FORGET_PASSWORD_OTP_SEND_Url,
//   FORGET_PASSWORD_RESET_Url,
//   OTP_REQUEST_Url,
//   UPDATE_FIRST_TIME_PASSWORD_Url,
// } from "../../../const/URL";
// import OtpInput from "../../../util/otpInput";
// import styles from "./VerifyOTP.module.scss";
// import { Button, Box, Typography } from "@mui/material";
// import fogotPsw from "../../../assets/images/forgot-password.png";
// import "../../../assets/fonts/poppins/poppins.css";

// interface IFormInput {
//   password: string;
// }

// const VerifyOTP = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const [otp, setOtp] = useState<string>("");
//   const [otpErrored, setOtpErrored] = useState<boolean>(false);
//   const [otpChecked, setOtpChecked] = useState<boolean>(false);
//   const [isLoading, setIsLoading] = useState<boolean>(false);
//   const [flow, setFlow] = useState<"FORGET_PASSWORD" | "FIRST_TIME_LOGIN">();
//   const [accessToken, setAccessToken] = useState<string>();
//   const [message, setMessage] = useState<{
//     type: string;
//     message: string;
//   }>({
//     type: "success",
//     message: "",
//   });

//   const {
//     register,
//     handleSubmit,
//     formState: { errors },
//   } = useForm<IFormInput>();
//   const handleChange = (otp: string) => {
//     setOtp(otp.trim());
//     setOtpErrored(false);
//     setOtpChecked(false);
//     if (otp.trim().length === 6) {
//       setOtpChecked(true);
//       setMessage({
//         type: "success",
//         message: "",
//       });
//     }
//   };

//   useEffect(() => {
//     if (location.state) {
//       const locationState = location.state as any;

//       if (locationState.flow === "FORGET_PASSWORD" && !locationState.username) {
//         return navigate("/forget-password");
//       } else if (
//         locationState.flow === "FIRST_TIME_LOGIN" &&
//         !locationState.username
//       ) {
//         return navigate("/");
//       }

//       setAccessToken(locationState.accessToken);
//       setFlow(locationState.flow);
//     }
//   }, [location, navigate]);

//   useEffect(() => {
//     if (flow && accessToken && flow === "FIRST_TIME_LOGIN") {
//       sendPasswordUpdateOtp();
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [flow, accessToken, navigate]);

//   const onSubmit: SubmitHandler<IFormInput> = (data) => {
//     const username = (location.state as any).username;
//     const password = data.password;
//     if (otpChecked && username) {
//       setIsLoading(true);

//       let endpointUrl = FORGET_PASSWORD_RESET_Url;

//       if (flow === "FIRST_TIME_LOGIN") {
//         endpointUrl = UPDATE_FIRST_TIME_PASSWORD_Url;
//       }

//       // eslint-disable-next-line @typescript-eslint/no-unused-vars
//       const config = {
//         method: "post",
//         url: endpointUrl,
//         data: {
//           username,
//           otpToken: otp,
//           newPassword: password,
//           confirmPassword: password,
//         },
//         headers: {
//           Authorization: "Bearer " + accessToken,
//         },
//       };

//       // axios(config)
//       //   .then((res) => {
//       //     setIsLoading(false);
//       //     setOtpErrored(false);
//       //     if (!res.data.isSuccess) {
//       //       setOtpErrored(true);
//       //       setMessage({
//       //         type: 'danger',
//       //         message: res.data.errorMessage,
//       //       });
//       //       return;
//       //     }

//       //     setMessage({
//       //       type: 'success',
//       //       message: 'Password changed successfully',
//       //     });
//       //     setTimeout(() => {
//       //       navigate('/');
//       //     }, 1000);
//       //   })
//       //   .catch((err) => {
//       //     setIsLoading(false);
//       //     setMessage({
//       //       type: 'danger',
//       //       message: err.data.errorMessage,
//       //     });
//       //   });
//       axios
//         .post(
//           endpointUrl,
//           {
//             username,
//             otpToken: otp,
//             newPassword: password,
//             confirmPassword: password,
//           },
//           {
//             headers: {
//               Authorization: "Bearer " + accessToken,
//             },
//           }
//         )
//         .then((res) => {
//           setIsLoading(false);
//           setOtpErrored(false);
//           if (!res.data.isSuccess) {
//             setOtpErrored(true);
//             setMessage({
//               type: "danger",
//               message: res.data.errorMessage,
//             });
//             return;
//           }

//           setMessage({
//             type: "success",
//             message: "Password changed successfully",
//           });
//           setTimeout(() => {
//             navigate("/");
//           }, 1000);
//         })
//         .catch((err) => {
//           setIsLoading(false);
//           setMessage({
//             type: "danger",
//             message: err.data.errorMessage,
//           });
//         });
//     }
//   };

//   const resendOtp = () => {
//     if (flow === "FIRST_TIME_LOGIN") {
//       if (!accessToken) {
//         navigate("/");
//         return;
//       }
//       setOtpChecked(true);
//       sendPasswordUpdateOtp();
//       return;
//     }
//     setIsLoading(true);
//     axios
//       .post(
//         FORGET_PASSWORD_OTP_SEND_Url +
//           "?username=" +
//           (location.state as any).username
//       )
//       .then((res) => {
//         setIsLoading(false);
//         if (res.status === 200 && res.data.isSuccess) {
//           setOtpErrored(false);
//           setOtp("");
//           setMessage({
//             type: "success",
//             message: "OTP resent successfully",
//           });
//         }
//         throw new Error(res.data.errorMessage);
//       })
//       .catch(() => {
//         setIsLoading(false);
//       });
//   };

//   const sendPasswordUpdateOtp = () => {
//     // const config = {
//     //   method: "post",
//     //   url: OTP_REQUEST_Url,
//     //   headers: {
//     //     Authorization: "Bearer " + accessToken,
//     //   },
//     // };

//     // axios(config).then((resp) => {
//     //   console.log(resp.data);
//     //   if (!resp.data.isSuccess) {
//     //     setMessage({
//     //       type: "danger",
//     //       message: resp.data.errorMessage,
//     //     });
//     //   } else {
//     //     setOtpErrored(false);
//     //     setOtp("");
//     //     setMessage({
//     //       type: "success",
//     //       message: "OTP sent successfully",
//     //     });
//     //   }
//     // });
//     axios
//       .post(OTP_REQUEST_Url, null, {
//         headers: {
//           Authorization: "Bearer " + accessToken,
//         },
//       })
//       .then((resp) => {
//         console.log(resp.data);
//         if (!resp.data.isSuccess) {
//           setMessage({
//             type: "danger",
//             message: resp.data.errorMessage,
//           });
//         } else {
//           setOtpErrored(false);
//           setOtp("");
//           setMessage({
//             type: "success",
//             message: "OTP sent successfully",
//           });
//         }
//       })
//       .catch((err) => {
//         // Handle any errors
//         setMessage({
//           type: "danger",
//           message: "An error occurred. Please try again.",
//         });
//       });
//   };

//   return (
//     <AuthScreenLayout>
//       <Row>
//         <Col className="mt-2 mb-1 poppins-semibold">
//           <Link to={"/"}>
//             <IoMdArrowBack color="black" />{" "}
//             <span className="text-black">Login</span>
//           </Link>
//         </Col>
//       </Row>
//       <Box
//         component="img"
//         src={fogotPsw}
//         alt="Logo"
//         sx={{
//           width: "250px",
//           height: "auto",
//           marginTop: 2,
//           mb: 1,
//         }}
//       />
//       <Row>
//         <Col className="text-center text-md-start">
//           <Title className="mt-4 mb-4 poppins-bold" color="black" fontSize={26}>
//             {flow === "FORGET_PASSWORD" ? "Forget" : "Update Your"} Password
//           </Title>
//         </Col>
//       </Row>
//       <Row>
//         <Col className="mb-2 mb-md-4 ">
//           <TextInfo
//             textAlign="left"
//             fontSize={16}
//             color="gray"
//             className="poppins-regular"
//           >
//             Enter 6 digits OTP code received to your e-mail to reset your
//             profile
//           </TextInfo>
//         </Col>
//       </Row>
//       <Row>
//         <Col className="mb-3">
//           {otpChecked && (
//             <TextInfo color={message.type} textAlign="center">
//               {message.message}
//             </TextInfo>
//           )}
//         </Col>
//       </Row>
//       <Row className="justify-content-center">
//         <Col className="col-auto">
//           <OtpInput
//             value={otp}
//             onChange={handleChange}
//             numInputs={6}
//             inputStyle={styles.otpInput}
//             containerStyle={styles.otpContainer}
//             errorStyle={styles.otpError}
//             isInputNum={true}
//             placeholder="000000"
//             hasErrored={otpErrored}
//           />
//         </Col>
//       </Row>
//       {otpChecked && !otpErrored && (
//         <form onSubmit={handleSubmit(onSubmit)}>
//           <Row>
//             <Col className="mt-3">
//               <TextInput
//                 textAlign="left"
//                 label="New Password"
//                 required
//                 color="gray"
//                 name="password"
//                 placeholder="🔒   Password"
//                 fontFamily="sans-serif"
//                 type="password"
//                 mode={EInputMode.light}
//                 useFormRegister={{
//                   ...register("password", { required: true, minLength: 8 }),
//                 }}
//                 errors={[
//                   {
//                     isShow: errors.password?.type === "required",
//                     message: "Password is required",
//                   },
//                   {
//                     isShow: errors.password?.type === "minLength",
//                     message: "Enter minimum 8 characters password",
//                   },
//                 ]}
//               />
//             </Col>
//           </Row>
//           <Row className="justify-content-end">
//             <Col className="mt-4 text-center">
//               {isLoading ? (
//                 <Spinner animation="border" variant="success" />
//               ) : (
//                 // <Button type="submit" className="w-100">
//                 //   Submit
//                 // </Button>
//                 <Box
//                   sx={{
//                     display: "flex",
//                     justifyContent: "center",
//                     alignItems: "flex-end",
//                     height: "100%",
//                   }}
//                 >
//                   <Button
//                     type="submit"
//                     sx={{
//                       background:
//                         "linear-gradient(80deg, rgb(37, 127, 223), rgb(31, 75, 155))",
//                       borderRadius: 30,
//                       color: "white",
//                       width: "300px",
//                       height: "50px",
//                       textAlign: "center",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       ":hover": {
//                         background: "#5C725A",
//                       },
//                     }}
//                   >
//                     Submit
//                   </Button>
//                 </Box>
//               )}
//             </Col>
//           </Row>
//         </form>
//       )}
//       <Row className="justify-content-center align-items-center mt-4 pb-4">
//         <Col className="col-auto ">
//           <TextInfo
//             textAlign="right"
//             color="blue"
//             className="poppins-bold"
//             fontWeight="bold"
//           >
//             Didn’t Receive OTP Yet?
//           </TextInfo>
//         </Col>
//         <Col className="col-auto">
//           {isLoading ? (
//             <Spinner animation="border" variant="success" />
//           ) : (
//             // <Button type="button" onClick={resendOtp}>
//             //   Resend
//             // </Button>
//             <Typography
//               onClick={resendOtp}
//               sx={{
//                 fontWeight: "bold",
//                 color: "#51B848",
//                 textTransform: "none",
//                 margin: 0,
//                 textDecoration: "underline",
//               }}
//             >
//               Resend OTP
//             </Typography>
//           )}
//         </Col>
//       </Row>
//     </AuthScreenLayout>
//   );
// };

// export default VerifyOTP;
import axios from "axios";
import { useEffect, useState } from "react";
import { Col, Row, Spinner } from "react-bootstrap";
import { SubmitHandler, useForm } from "react-hook-form";
import { IoMdArrowBack } from "react-icons/io";
import { Link, useLocation, useNavigate } from "react-router-dom";
import AuthScreenLayout from "../../../components/authScreenLayout/AuthScreenLayout";
import TextInfo from "../../../components/textInfo/TextInfo";
import TextInput, { EInputMode } from "../../../components/textInput/TextInput";
import Title from "../../../components/title/Title";
import {
  FORGET_PASSWORD_OTP_SEND_Url,
  FORGET_PASSWORD_RESET_Url,
  OTP_REQUEST_Url,
  VERIFY_USER_LOGIN_Url,
} from "../../../const/URL";
import OtpInput from "../../../util/otpInput";
import styles from "./VerifyOTP.module.scss";
import { Button, Box, Typography } from "@mui/material";
import fogotPsw from "../../../assets/images/forgot-password.png";
import "../../../assets/fonts/poppins/poppins.css";
import { SUCCESS_LOGIN, AUTH_LOADING } from "../../../const/actionTypes";
import { useDispatch } from "react-redux";
import { request } from "http";
import { ILoginIntoResponse } from "../../../interfaces/loginIntoResponce";
import { IChangeContactFormInputs } from "../../dashboard/changeContact/ChangeContact";

interface IFormInput {
  password: string;
}

const VerifyOTP = () => {
  const dispatch: any = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [otp, setOtp] = useState<string>("");
  const [otpErrored, setOtpErrored] = useState<boolean>(false);
  const [otpChecked, setOtpChecked] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [flow, setFlow] = useState<
    "FORGET_PASSWORD" | "FIRST_TIME_LOGIN" | "REGULAR_LOGIN"
  >();
  const [accessToken, setAccessToken] = useState<string>();
  const [requestToken, setRequestToken] = useState<string>();
  const [otpReference, setOtpReference] = useState<string>();

  const validateNewPassword = (value: string) => {
    if (!value) {
      return "Please enter a new password";
    }
    const pattern =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*_=+-]).{8,40}$/;
    if (!pattern.test(value)) {
      return "Your password must be at least 8 characters long and include an uppercase letter, a lowercase letter, a number, and a special character.";
    }
    return true;
  };

  const [message, setMessage] = useState<{
    type: string;
    message: string;
  }>({
    type: "success",
    message: "",
  });

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    trigger,
    formState: { errors },
  } = useForm<IFormInput>();

  const newPassword = watch("password");

  useEffect(() => {
    if (newPassword) {
      trigger("password");
    }
  }, [newPassword, trigger]);

  const handleChange = (otp: string) => {
    setOtp(otp.trim());
    setOtpErrored(false);
    setOtpChecked(false);
    if (otp.trim().length === 6) {
      setOtpChecked(true);
      setMessage({
        type: "success",
        message: "",
      });
    }
  };

  useEffect(() => {
    if (location.state) {
      const locationState = location.state as any;

      if (locationState.flow === "FORGET_PASSWORD" && !locationState.username) {
        return navigate("/forget-password");
      }
      // else if (
      //   locationState.flow === "FIRST_TIME_LOGIN" &&
      //   !locationState.username
      // ) {
      //   return navigate("/");
      // } else if (
      //   locationState.flow === "REGULAR_LOGIN" &&
      //   !locationState.username
      // ) {
      //   return navigate("/");
      // }
      setOtpReference(locationState.otp_reference);
      setRequestToken(locationState.request_token);
      setFlow(locationState.flow);
    }
  }, [location, navigate]);

  // useEffect(() => {
  //   if (flow && accessToken && flow === "FIRST_TIME_LOGIN") {
  //     sendPasswordUpdateOtp();
  //   } else if (flow && accessToken && flow === "REGULAR_LOGIN") {
  //     sendPasswordUpdateOtp();
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [flow, accessToken, navigate]);

  const onSubmit: SubmitHandler<IFormInput> = (data) => {
    const username = (location.state as any).username;
    const password = data.password;
    const oldPassword = (location.state as any).oldPassword;
    if (isLoading) {
      return;
    }
    if (otpChecked && username) {
      setIsLoading(true);

      let endpointUrl = VERIFY_USER_LOGIN_Url;

      if (flow === "FORGET_PASSWORD") {
        endpointUrl = FORGET_PASSWORD_RESET_Url;

        axios
          .post(
            endpointUrl,
            {
              otpToken: otp,
              username: (location.state as any).username,
              newPassword: password,
              confirmPassword: password,
            },
            {
              headers: {
                Authorization: "Bearer " + accessToken,
              },
            }
          )
          .then((res) => {
            setIsLoading(false);
            setOtpErrored(false);
            if (!res.data.isSuccess) {
              setOtpErrored(true);
              setMessage({
                type: "danger",
                message: res.data.errorMessage,
              });
              return;
            }

            setMessage({
              type: "success",
              message: "Password changed successfully",
            });
            setTimeout(() => {
              navigate("/");
            }, 1000);
          })
          .catch((err) => {
            setIsLoading(false);
            setMessage({
              type: "danger",
              message: err.data.errorMessage,
            });
          });
      }

      if (flow === "FIRST_TIME_LOGIN") {
        axios
          .post(
            endpointUrl,
            {
              otp: otp,
              requestToken: requestToken,
              otpReference: otpReference,
              newPassword: password,
              oldPassword: oldPassword,
            }
            // {
            //   headers: {
            //     Authorization: "Bearer " + accessToken,
            //   },
            // }
          )
          .then((res) => {
            setIsLoading(false);
            if (res.data.isSuccess === false) {
              const errorMessage =
                res?.data?.errorMessage || "An unexpected error occurred";

              setMessage({
                type: "danger",
                message: errorMessage,
              });
            } else {
              setOtpErrored(false);

              setMessage({
                type: "success",
                message: "Password changed successfully",
              });
              dispatch({
                payload: res?.data,
                type: SUCCESS_LOGIN,
              });
            }
          })
          .catch((err) => {
            setIsLoading(false);
            setMessage({
              type: "danger",
              message: err.data.errorMessage,
            });
          });
      }
      if (flow === "REGULAR_LOGIN") {
        axios
          .post(endpointUrl, {
            otp: otp,
            requestToken: requestToken,
            otpReference: otpReference,
          })
          .then((res) => {
            setIsLoading(false);

            if (res.data.isSuccess === false) {
              const errorMessage =
                res?.data?.errorMessage || "An unexpected error occurred";

              setMessage({
                type: "danger",
                message: errorMessage,
              });
            } else {
              setOtpErrored(false);
              setMessage({
                type: "success",
                message: "Login successfully",
              });
              dispatch({
                payload: res?.data,
                type: SUCCESS_LOGIN,
              });
            }
          })
          .catch((error) => {
            setIsLoading(false);

            const errorMessage =
              error?.response?.data?.errorMessage ||
              "An unexpected error occurred";

            setMessage({
              type: "danger",
              message: errorMessage,
            });

            console.error("API Error:", errorMessage);
          });
      }
    }
  };

  const resendOtp = () => {
    if (isLoading) {
      return;
    }
    let endpointUrl = OTP_REQUEST_Url;

    if (flow === "FORGET_PASSWORD") {
      endpointUrl =
        FORGET_PASSWORD_OTP_SEND_Url +
        "?username=" +
        (location.state as any).username;
    }
    setIsLoading(true);
    axios
      .post(endpointUrl, {
        requestToken: requestToken,
        otpReference: otpReference,
      })
      .then((res) => {
        setIsLoading(false);
        if (res.status === 200) {
          setOtpChecked(true);
          const message = res.data.message;
          setOtpErrored(false);
          setOtp("");
          setMessage({
            type: "success",
            message: message || "OTP sent successfully",
          });
        }
        // throw new Error(res.data.errorMessage);
      })
      .catch((error) => {
        setIsLoading(false);

        const errorMessage =
          error?.response?.data?.errorMessage || "An unexpected error occurred";

        setMessage({
          type: "danger",
          message: errorMessage,
        });

        console.error("API Error:", errorMessage);
      });
  };

  const sendPasswordUpdateOtp = () => {
    axios
      .post(OTP_REQUEST_Url, null, {
        headers: {
          Authorization: "Bearer " + accessToken,
        },
      })
      .then((resp) => {
        console.log(resp.data);
        if (!resp.data.isSuccess) {
          setMessage({
            type: "danger",
            message: resp.data.errorMessage,
          });
        } else {
          setOtpErrored(false);
          setOtp("");
          setMessage({
            type: "success",
            message: "OTP sent successfully",
          });
        }
      })
      .catch((err) => {
        // Handle any errors
        setMessage({
          type: "danger",
          message: "An error occurred. Please try again.",
        });
      });
  };

  return (
    <AuthScreenLayout>
      <Row>
        <Col className="mt-2 mb-1 poppins-semibold">
          <Link to={"/"}>
            <IoMdArrowBack color="black" />{" "}
            <span className="text-black">Login</span>
          </Link>
        </Col>
      </Row>
      <Box
        component="img"
        src={fogotPsw}
        alt="Logo"
        sx={{
          width: "150px",
          height: "80px",
          marginTop: 2,
          mb: 1,
        }}
      />
      <Row>
        <Col className="text-center text-md-start">
          <Title className="mt-4 mb-4 poppins-bold" color="black" fontSize={26}>
            {flow === "FORGET_PASSWORD"
              ? "Forget Password"
              : flow === "FIRST_TIME_LOGIN"
              ? "Update Your Password"
              : "Enter Verification Code"}
          </Title>
        </Col>
      </Row>
      <Row>
        <Col className="mb-2 mb-md-4 ">
          <TextInfo
            textAlign="center"
            fontSize={16}
            color="gray"
            className="poppins-regular"
          >
            Enter 6 digits OTP code received to your <br /> e-mail/mobile to
            validate your profile
          </TextInfo>
        </Col>
      </Row>
      <Row>
        <Col className="mb-3">
          {otpChecked && (
            <TextInfo color={message.type} textAlign="center">
              {message.message}
            </TextInfo>
          )}
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col className="col-auto">
          <OtpInput
            value={otp}
            onChange={handleChange}
            numInputs={6}
            inputStyle={styles.otpInput}
            containerStyle={styles.otpContainer}
            errorStyle={styles.otpError}
            isInputNum={true}
            placeholder="000000"
            hasErrored={otpErrored}
            onKeyDown={(e: any) => {
              if (e.key === "Enter" && !isLoading) {
                handleSubmit(onSubmit)();
              }
            }}
          />
        </Col>
      </Row>

      {flow !== "REGULAR_LOGIN" && (
        <>
          {otpChecked && !otpErrored && (
            <form onSubmit={handleSubmit(onSubmit)}>
              <Row>
                <Col className="mt-3">
                  <TextInput
                    textAlign="left"
                    label="New Password"
                    required
                    color="gray"
                    name="password"
                    placeholder="🔒   Password"
                    fontFamily="sans-serif"
                    type="password"
                    value={watch("password")}
                    mode={EInputMode.light}
                    useFormRegister={{
                      ...register("password", {
                        required: true,
                        minLength: 1,
                        validate: validateNewPassword,
                      }),
                    }}
                    errors={[
                      {
                        isShow: !!errors.password,
                        message: errors.password?.message || "",
                      },
                    ]}
                  />
                </Col>
              </Row>
              <Row className="justify-content-end">
                <Col className="mt-4 text-center">
                  {isLoading ? (
                    <Spinner animation="border" variant="success" />
                  ) : (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "flex-end",
                        height: "100%",
                      }}
                    >
                      <Button
                        type="submit"
                        sx={{
                          background:
                            "linear-gradient(80deg, rgb(37, 127, 223), rgb(31, 75, 155))",
                          borderRadius: 30,
                          color: "white",
                          width: "300px",
                          height: "50px",
                          textAlign: "center",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          ":hover": {
                            background: "#5C725A",
                          },
                        }}
                      >
                        Submit
                      </Button>
                    </Box>
                  )}
                </Col>
              </Row>
            </form>
          )}
        </>
      )}

      {flow === "REGULAR_LOGIN" && (
        <>
          {otpChecked && !otpErrored && (
            <form onSubmit={handleSubmit(onSubmit)}>
              <Row className="justify-content-end">
                <Col className="mt-4 text-center">
                  {isLoading ? (
                    <Spinner animation="border" variant="success" />
                  ) : (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "flex-end",
                        height: "100%",
                      }}
                    >
                      <Button
                        type="submit"
                        sx={{
                          background:
                            "linear-gradient(80deg, rgb(37, 127, 223), rgb(31, 75, 155))",
                          borderRadius: 30,
                          color: "white",
                          width: "300px",
                          height: "50px",
                          textAlign: "center",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          ":hover": {
                            background: "#5C725A",
                          },
                        }}
                      >
                        Submit
                      </Button>
                    </Box>
                  )}
                </Col>
              </Row>
            </form>
          )}
        </>
      )}

      <Row className="justify-content-center align-items-center mt-4 pb-4">
        <Col className="col-auto ">
          <TextInfo
            textAlign="right"
            color="blue"
            className="poppins-bold"
            fontWeight="bold"
          >
            Didn’t receive OTP yet?
          </TextInfo>
        </Col>
        <Col className="col-auto">
          {isLoading ? (
            <Spinner animation="border" variant="success" />
          ) : (
            <Typography
              onClick={resendOtp}
              sx={{
                fontWeight: "bold",
                color: "#51B848",
                textTransform: "none",
                margin: 0,
                textDecoration: "underline",
                cursor: "pointer",
              }}
            >
              Resend OTP
            </Typography>
          )}
        </Col>
      </Row>
    </AuthScreenLayout>
  );
};

export default VerifyOTP;
